export default "__VITE_ASSET__BL66GaQM__"